import React, { useState } from 'react';
import Form from '../../Modules/form/components/Form';
import { Card, CardBody, FormGroup, Label, Row, Col, Button } from 'reactstrap';
import Box from '@material-ui/core/Box';

import AgencyMultiselect from '../../Modules/form/components/specialized/AgencyMultiSelect';
import LocationSelect from '../../Modules/form/components/specialized/LocationSelect';
import NurseDeploymentFixationSelect from '../../Modules/form/components/specialized/NurseDeploymentFixationSelect';
import ProvisionMonthSelect from '../../Modules/form/components/specialized/ProvisionMonthSelect';
import DateInput from '../../Modules/form/components/DateInput';

import { exportDataRequest } from './hooks';
import LoadingButton from '../Helpers/LoadingButton';

import { storeNurseDeploymentFixation } from '../../Modules/nurseDeploymentFixation/nurseDeploymentFixationSlice';
import { useDispatch } from 'react-redux';


const FORM_KEY = 'provision-export';
const EXPORT_TYPE = 'provision';

const ProvisionExport = () => {
    const [loading, setLoading] = useState(false);
    const [errorDownload, setErrorDownload] = useState(null);
    const [errorFixation, setErrorFixation] = useState(null);
    const dispatch = useDispatch();

    const handleFixationSubmit = async (values) => {
        setErrorFixation(null);
        if (!values.month_fixation) {
            setErrorFixation(new Error("Bitte 'Monat der Fixierung' auswählen!"));
            return;
        }

        return Promise.all([
            dispatch(storeNurseDeploymentFixation({ fixedAt: values.date_fixation, fixationMonth: values.month_fixation })),
        ]);

    };

    const handleExportSubmit = async (values) => {
        setErrorDownload(null);
        console.log('Export values:', values);

        if (values.date_from && values.date_till) {
            const fromDate = new Date(values.date_from);
            const tillDate = new Date(values.date_till);
            if (isNaN(fromDate) || isNaN(tillDate)) {
                setErrorDownload(new Error('Ungültiges Datum im Zeitraum!'));
                return;
            }
            if (fromDate > tillDate) {
                setErrorDownload(new Error('Das Startdatum darf nicht nach dem Enddatum liegen!'));
                return;
            }
        }
        else if (values.provision_month)
        {
            const monthDate = new Date(values.provision_month);
            if (isNaN(monthDate)) {
                setErrorDownload(new Error('Ungültiger Monat!'));
                return;
            }
        }
        else {
            setErrorDownload(new Error('Bitte einen Zeitraum oder Monat auswählen!'));
            return;
        }

        // // make sure either agency or location is selected
        // if (!values.agency && !values.location) {
        //     setErrorDownload(new Error('Bitte eine Agentur oder einen Standort auswählen!'));
        //     return;
        // }

        try {
            setLoading(true);
            await exportDataRequest(EXPORT_TYPE, values);
        } catch (err) {
            errorDownload(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box mt={3}>
            <Card data-cy="card-provisionexport">
                <h6 className="card-header">Provisionsabrechnungs-Excel-Datei</h6>
                <CardBody>
                    <p>
                        Unter folgendem Link kann die Datei für die Provisionsabrechnung heruntergeladen
                        werden.
                    </p>
                    <Form
                        onSubmit={handleExportSubmit}
                    >
                        <Row>
                            <Col>
                                <FormGroup>
                                    <DateInput
                                        label="Zeitraum vom:"
                                        name="date_from"
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <DateInput
                                        label="bis:"
                                        name="date_till"
                                    />
                                </FormGroup>
                            </Col>
                              <Col className="text-center">
                                <br />
                                oder Monat
                            </Col>
                            <Col>
                                <ProvisionMonthSelect
                                    name="provision_month"
                                    fullWidth
                                    label="Monat"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Agentur:</Label>
                                    <AgencyMultiselect
                                        name="agency"
                                        label="Agentur"
                                        fullWidth
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="text-center">
                                <br />
                                und / oder
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label>Standort:</Label>
                                     <LocationSelect
                                        name="location"
                                        label="Standort"
                                        fullWidth
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="text-center">
                            <LoadingButton
                                color="primary"
                                id={FORM_KEY}
                                title="Klicken um die Datei herunterzuladen"
                                type="submit"
                                isLoading={loading}
                            >
                                Herunterladen
                            </LoadingButton>
                            <Button type="reset" color="secondary" className="ml-2">
                                Zurücksetzen
                            </Button>
                        </div>
                        {errorDownload && <div className="text-danger">{errorDownload.message}</div>}
                    </Form>
                </CardBody>
            </Card>
            <Card data-cy="card-provisionexport">
                <h6 className="card-header">BK-Verlauf fixiert am:</h6>
                <CardBody>
                    <p>
                        Hier kann der BK-Verlauf für einen bestimmten Monat fixiert werden.
                    </p>
                    <Form
                        onSubmit={handleFixationSubmit}
                        initialValues={{ date_fixation: new Date()}}
                    >
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Col>
                                        <ProvisionMonthSelect
                                            name="month_fixation"
                                            fullWidth
                                            label="Monat der Fixierung"
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <DateInput
                                        label="Zeitraum vom:"
                                        name="date_fixation"
                                        disabled={true}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Vergangene BK-Verlauf Fixierungen:</Label>
                                    <NurseDeploymentFixationSelect
                                        name="fixations"
                                        fullWidth
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="text-center">
                            <LoadingButton
                                color="primary"
                                id={FORM_KEY}
                                title="Klicken um den BK-Verlauf zu fixieren"
                                type="submit"
                                isLoading={loading}
                            >
                                Jetzt Fixieren
                            </LoadingButton>
                            <Button type="reset" color="secondary" className="ml-2" onClick={() => setErrorFixation(null)}>
                                Abbrechen
                            </Button>
                        </div>
                        {errorFixation && <div className="text-danger">{errorFixation.message}</div>}
                    </Form>
                </CardBody>
            </Card>
        </Box>
    );
};

ProvisionExport.propTypes = {

};

ProvisionExport.defaultProps = {

};

export default ProvisionExport;
